/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_VisibilityInputs */

const en_dialog_visibility = /** @type {(inputs: Dialog_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility`)
};

const es_dialog_visibility = /** @type {(inputs: Dialog_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibilidad`)
};

/**
* | output |
* | --- |
* | "Visibility" |
*
* @param {Dialog_VisibilityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_visibility = /** @type {((inputs?: Dialog_VisibilityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_VisibilityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_visibility(inputs)
	return en_dialog_visibility(inputs)
});